'use client';
import Hyperlink from '@/components/ui/hyperlink';
import { homeService } from '@/data/data';
import Image from 'next/image';

const ServiceArea = () => {
    return (
        <section
            className={`desilo-service4-section overflow-hidden section-padding-top-bottom`}
            id="service-section"
        >
            <div className="container custom-container">
                <div className="row gx-4 gy-5">
                    <div className="col-md-10">

                        {/*col-lg-8 col-xxl-6*/}
                        <div className="desilo__header row-padding-bottom text-left text-md-start">
                            <h2 className="title">
                                Our services: End-to-end product & growth
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {/* service card start */}
                        {homeService.slice(0, 4).map((item, i) => (
                            <div className="desilo-service-box4 fade-anim" key={i}>
                                <h3 className="service-title">{item.title}</h3>
                                <div className="service-info">
                                    <p>{item.description}</p>
                                    <Hyperlink 
                                        className='view-more' 
                                        href={`/service${item.url}`}
                                        aria-label={`View more about our ${item.title} services`}
                                    >
                                        View more
                                    </Hyperlink>
                                    <div className="blog-item">
                                        <div className="blog-tags mt-0">
                                            <ul className="custom-ul">
                                                {item?.tags?.map((tag, index) => (
                                                    <li key={index}>
                                                        <span className="service-tags">{tag}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="desilo-iconbox-icon">
                                    <Image
                                        height={52}
                                        width={52}
                                        src={item?.icon}
                                        alt="service-icon"
                                    />
                                </div>
                            </div>
                        ))}
                        {/* service card end */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceArea;
